import _ from 'lodash'

type BulkCallback<T> = (xs: T[]) => any

export function BulkThrottle<T>(cb: BulkCallback<T>, ms=1000){
  const pending = new Set<T>()
  const doer = _.throttle(() => {
    cb(Array.from(pending.keys()))
    pending.clear()
  }, ms)
  return (...items: T[]) => {
    _.forEach(items, item => pending.add(item))
    doer()
  }
}